import { px2rem } from "@moim/common";
import { Svg18RightarrowG, Svg18RetryB } from "@moim/icons";
import styled from "styled-components";
import { SectionTitle as SectionTitleBase } from "../../styledComponent";

export const Container = styled.div`
  width: 100%;
  padding: ${px2rem(8)} ${px2rem(16)};
`;
export const SectionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RightArrow = styled(Svg18RightarrowG).attrs(props => ({
  size: "xs",
  touch: 42,
  iconColor: props.theme.colorV2.colorSet.grey300,
}))``;

export const SectionTitle = styled(SectionTitleBase)`
  display: flex;
  align-items: center;
  gap: ${px2rem(4)};
`;

export const RetryIcon = styled(Svg18RetryB).attrs(props => ({
  size: "xs",
  iconColor: props.theme.colorV2.colorSet.grey800,
}))``;
